import { Flex, Text } from "@chakra-ui/react";
import Lottie from "lottie-react";
import * as animationData from "@/assets/loading-user.json";

const LoadingPage = ({ text }: { text: string }) => {
  return (
    <Flex
      sx={{ height: "100%", justifyContent: "center", alignItems: "center" }}
      flexDir={"column"}
    >
      <Lottie
        animationData={animationData}
        loop={true}
        style={{
          width: "40px",
          height: "40px",
        }}
      />
      <Text
        sx={{
          color: "#FFF",
          textAlign: "center",
          fontSize: "14px",
          fontWeight: 500,
          marginTop: "20px",
        }}
      >
        {text}
      </Text>
    </Flex>
  );
};

export default LoadingPage;
